/**
 * Processing progress display for binder upload page.
 */

import React from 'react';

interface ProcessingProgressProps {
  processingStatus: {
    phase?: string;
    percent_complete: number;
    resumes_processed: number;
    total_resumes: number;
    evaluations_in_db?: number;
    resumes_detected?: number;
    is_incomplete?: boolean;
  };
  autoRetryCount: number;
  maxAutoRetries: number;
}

const ProcessingProgress: React.FC<ProcessingProgressProps> = ({
  processingStatus,
  autoRetryCount,
  maxAutoRetries
}) => (
  <div style={{ marginTop: '24px' }}>
    <h3 style={{
      fontSize: '16px',
      fontWeight: 600,
      color: '#1a1a1a',
      marginBottom: '12px',
      textTransform: 'capitalize'
    }}>
      {processingStatus.phase || 'Processing'}
    </h3>
    <div style={{
      height: '8px',
      background: '#e5e7eb',
      borderRadius: '4px',
      overflow: 'hidden'
    }}>
      <div style={{
        height: '100%',
        width: `${processingStatus.percent_complete}%`,
        background: '#2d5016',
        transition: 'width 0.3s'
      }} />
    </div>
    <p style={{
      marginTop: '8px',
      textAlign: 'center',
      fontSize: '14px',
      color: '#6b7280'
    }}>
      {processingStatus.percent_complete}% complete
    </p>
    <p style={{
      marginTop: '4px',
      textAlign: 'center',
      fontSize: '14px',
      color: '#6b7280'
    }}>
      Processing resume {processingStatus.resumes_processed} / {processingStatus.total_resumes}
    </p>
    {processingStatus.evaluations_in_db != null && processingStatus.evaluations_in_db > 0 && (
      <p style={{
        marginTop: '4px',
        textAlign: 'center',
        fontSize: '13px',
        color: processingStatus.is_incomplete ? '#dc2626' : '#059669',
        fontWeight: 600
      }}>
        {processingStatus.is_incomplete && '\u26A0\uFE0F '}
        {processingStatus.evaluations_in_db} / {processingStatus.resumes_detected} candidates saved
        {processingStatus.is_incomplete && ' (incomplete)'}
      </p>
    )}
    <div style={{
      marginTop: '16px',
      padding: '12px 16px',
      background: '#eff6ff',
      color: '#1e40af',
      borderRadius: '8px',
      fontSize: '14px',
      textAlign: 'center'
    }}>
      {autoRetryCount > 0
        ? `Auto-retrying (attempt ${autoRetryCount}/${maxAutoRetries})... Processing continues in the background.`
        : 'You can safely close this page. Processing will continue in the background.'
      }
    </div>
  </div>
);

export default ProcessingProgress;
